import { environment } from '../../../../environments/environment';
import { Link } from '../../../models/link';

export const domainSwap = (urlOrLink: string | Link, returnAsString: boolean = true) => {
  let result: string | Link;
  try {
    const urlString = typeof urlOrLink === 'string' ? urlOrLink : urlOrLink.href;
    const url = new URL(urlString);

    if (url.hostname === environment.swapApiDomainFrom) {
      url.hostname = environment.swapApiDomainTo;
    }

    result = typeof urlOrLink === 'string' ? url.toString() : { ...urlOrLink, href: url.toString() };
  } catch (error) {
    return urlOrLink;
  }

  return returnAsString ? (result as string) : (result as Link);
};

export default domainSwap;
